import { NgModule } from '@angular/core';
import { ActivePartnerDirective } from './directives/active-partner.directive';
import { HasPartnerFeatureDirective } from './directives/has-partner-feature.directive';
import { IfActiveStayDirective } from './directives/if-active-stay.directive';
import { NearestStayStartDatePipe } from './nearest-stay-start-date.pipe';
import { StayRefresherDirective } from './directives/stay-refresher.directive';

@NgModule({
    imports: [],
    exports: [
        ActivePartnerDirective,
        IfActiveStayDirective,
        StayRefresherDirective,
        NearestStayStartDatePipe,
        HasPartnerFeatureDirective,
    ],
    declarations: [
        IfActiveStayDirective,
        ActivePartnerDirective,
        StayRefresherDirective,
        NearestStayStartDatePipe,
        HasPartnerFeatureDirective,
    ],
    providers: [],
})
export class KatchaStayModule { }
